'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var RadioCard = require('../../../components/RadioCard/RadioCard.js');
var Typography = require('../../../components/Typography.js');
var Box = require('../../../components/layout/Box/Box.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ClaimSummaryAppeasementOption = _ref => {
  let {
    selected = false,
    name,
    value,
    onChange,
    title,
    description
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(RadioCard["default"], {
    id: value,
    name: name,
    value: value,
    selected: selected ?? undefined,
    onChange: onChange
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 1
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "div"
  }, title), description && /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, description)));
};

exports["default"] = ClaimSummaryAppeasementOption;
